import React, { useState, useEffect } from 'react';
import { Link as RouterLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';


import { useTranslation } from 'react-i18next'
import auth from '../../../utils/auth';
import request from '../../../utils/request';
import { makeStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import axios from 'axios';
import cookie from 'react-cookies';

import PelotonCard from './Components/PelotonCard.js';

import {
	AppBar,
	Grid,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField,
  Paper,
  InputLabel,
  Input,
} from '@material-ui/core';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1)
  },
  topBar:{
		paddingBottom: '8px',
		borderBottom: '1px #dddddd solid',
	},
	whiteLine: {
		borderBottom: '1px #ffffff solid',
		marginBottom:'16px',	
	},
	title: {
		fontSize:'16px',		 
		color:'#73838b', fontWeight:'500',
		padding:'0px',
		[theme.breakpoints.up("md")]: {
			fontSize:'20px',
		},
	},
  desc: {
    margin:"12px 0 12px 0",
    padding:"12px",
    background:"#f5f5f5"
  },
  textField: {
    marginTop: theme.spacing(2),
  },

}));

const Main = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [createOpen, setCreateOpen] = React.useState(false);
  const createFullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleCreateOpen = () => {
    setCreateOpen(true);
  };
  const handleCreateClose = () => {
    setCreateOpen(false);
  };

	const token = auth.getToken().token; 
	const extraInfo = auth.getExtraInfo() ? auth.getExtraInfo() : {pretest : 'none'};
	const auth_str = 'Bearer '.concat((auth.getToken().token)); 
	const [ pelotonList, setPelotonList ] = React.useState([]);

  // 펠로톤 등록
  const [clubFormData, setClubFormData] = useState({
    name: '',
    description: '',
    country: '',
    city: '',
    category: 0,
  });

  // 이미지 파일
  const [imageFiles, setImageFiles] = React.useState([]);

  //다국어적용
  const { t }  = useTranslation(['page']);

  //const [popoverOpenInvite, setPopoverOpenInvite] = React.useState(false);
  useEffect(() => {

    // 펠로톤 클럽 리스트 가져오기
    axios.get(
      `${process.env.REACT_APP_PELOTON_RESTAPI_BASE_URL}/api/club/search`, 
      { 
        headers: { Authorization: auth_str }, 
        params: { 
          data:'{}',
          page:0,
          size:12,
        }
      }
    ).then(function (response) {
      const items = response.data.response.content;
      setPelotonList(items); 
    }).catch(function (err) {
      console.log(err);
    })

  }, []);

  const handleCreateFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setClubFormData(prevFormData => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value
    }));
  }

  const handleImageChange = (e) => {
    // 파일 목록을 배열로 변환하고, 상태에 저장
    setImageFiles([...e.target.files]);
  };

  // 펠로톤 클럽 등록
  const handleCreateSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = new FormData();
    dataToSend.append('data', JSON.stringify(clubFormData)); // JSON 데이터를 'data' 키에 문자열로 추가

    // 이미지 파일 추가
    imageFiles.forEach((file) => {
        dataToSend.append('files', file, file.name);
    });

    try {
      const response = await axios.post(`${process.env.REACT_APP_PELOTON_RESTAPI_BASE_URL}/api/club`, dataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: auth_str 
        }
      });
      console.log('Response:', response.data);
      if(response.data.success){
        // response.data.response <- 신규 생선된 펠로톤 클럽 id(번호)
        alert('펠로톤 신청이 완료되었습니다.');
        handleCreateClose();
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  function workoutOpen() {
    var form = document.createElement("form");
    form.action = 'https://workout.riduck.com/'; 
    form.method = "POST";
    form.target = "_blank";

    var input = document.createElement("input");
    input.name = "jwt";
    input.value = token;
    form.appendChild(input);
    //.concat((auth.getToken().token))

    form.style.display = 'none';
    document.body.appendChild(form);

    form.submit();
  }


  function feedbackOpen() {
    var form = document.createElement("form");
    form.action = `${process.env.REACT_APP_RESTAPI_BASE_URL}/slowtwitch/connect_slowtwitch`; 
    form.method = "POST";
    form.target = "_blank";

    var input = document.createElement("input");
    input.name = "jwt";
    input.value = token;
    form.appendChild(input);
    //.concat((auth.getToken().token))

    form.style.display = 'none';
    document.body.appendChild(form);

    form.submit();
  }
  

  function reportOpen() {
    var form = document.createElement("form");
    form.action = 'https://report.riduck.com/report_downloader'; 
    form.method = "POST";
    form.target = "_blank";

    var input = document.createElement("input");
    input.name = "jwt";
    input.value = token;
    form.appendChild(input);
    //.concat((auth.getToken().token))

    form.style.display = 'none';
    document.body.appendChild(form);

    form.submit();
  }


  function strategyOpen() {
    var form = document.createElement("form");
    form.action = 'https://report.riduck.com/seorak'; 
    form.method = "POST";
    form.target = "_blank";

    var input = document.createElement("input");
    input.name = "jwt";
    input.value = token;
    form.appendChild(input);
    //.concat((auth.getToken().token))

    form.style.display = 'none';
    document.body.appendChild(form);

    form.submit();
  }


  return (
    <React.Fragment>
      <Paper style={{padding:'16px'}}>
          <Typography 
            component="div"
          >
            1) 라이덕 펠로톤은 라이덕 등급을 통해 자신의 실력과 비슷한 사람들과 라이딩할 수 있습니다.   
          </Typography>
          <Typography 
            component="div"
          >
            2) 사전에 코스와 참가자들의 역량 데이터를 바탕으로 시뮬레이션하여 모두가 즐길 수 있는 라이딩 가이드를 제시합니다.    
          </Typography>
          <Typography 
            component="div"
          >
            3) 그룹 라이딩을 끝마치고 결과를 분석해줍니다. 누가 가장 빠르게 탔는지도 중요하지만, 가장 열심히 탄 사람과 효율적으로 탄 사람을 분석해드립니다.          
          </Typography>
          <Typography 
            component="div"
          >
            4) 대회를 위한 훈련과 팀단위 훈련 경쟁 이벤트 다양한 목적으로 펠로톤을 만들어 효과적인 그룹 트레이닝 도구로 활용해보세요           
          </Typography>

          <Typography 
            component="div"
          >
          지금 펠로톤을 개설하세요. 
          </Typography>

          <Box style={{textAlign:'center'}}> 
            <Button variant="contained" color="primary" onClick={handleCreateOpen}>펠로톤 신청하기</Button>
          </Box>

          <Dialog
            id="create-peloton-dialog" 
            fullScreen={createFullScreen}
            open={createOpen}
            onClose={handleCreateClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">{"펠로톤 신청하기"}</DialogTitle>
            <form onSubmit={handleCreateSubmit}>
              <DialogContent>
                <DialogContentText>
                  다음 양식에 맞게 신청해주세요. 운영자가 24시간 이내에 확인 후 승인해드립니다. 
                </DialogContentText>

                <TextField
                  label="이름"
                  name="name"
                  value={clubFormData.name}
                  onChange={handleCreateFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="설명"
                  name="description"
                  value={clubFormData.description}
                  onChange={handleCreateFormChange}
                  multiline
                  rows={4}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="국가"
                  name="country"
                  value={clubFormData.country}
                  onChange={handleCreateFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="지역"
                  name="city"
                  value={clubFormData.city}
                  onChange={handleCreateFormChange}
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="등급"
                  name="category"
                  value={clubFormData.category}
                  onChange={handleCreateFormChange}
                  type="number"
                  fullWidth
                  margin="normal"
                />
                <InputLabel htmlFor="image-upload">대표사진</InputLabel>
                <Input
                  id="image-upload"
                  name="image"
                  type="file"
                  onChange={handleImageChange}
                  inputProps={{ accept: "image/jpeg, image/png" }}
                />
              </DialogContent>
              <DialogActions>
                <Button autoFocus onClick={handleCreateClose} color="primary">
                  취소하기
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  신청하기
                </Button>
              </DialogActions>
            </form>
          </Dialog>
      </Paper>


      <Box style={{"margin":"12px 0"}}>    
      </Box>
  
      <Box style={{"margin":"12px 0"}}>    
			<Grid container spacing={2}>
        {pelotonList.map((peloton, i) => (								
          <Grid item lg={4} md={6} sm={6} xs={12} key={i}>
            <PelotonCard peloton={peloton}></PelotonCard>
          </Grid>
				))}
			</Grid>
      </Box>
    </React.Fragment>
  );
};

Main.propTypes = {
  history: PropTypes.object
};

export default withRouter(Main);
